// Make sure to import each new calendar and materials into courses.js!
import { fall_2026_3200_materials } from "./materials/fall_2026_3200_materials.js";
import { fall_2026_3200_calendar } from "./calendars/fall_2026_3200_calendar.js";
import { fall_2026_2260_materials } from "./materials/fall_2026_2260_materials.js";
import { fall_2026_2260_calendar } from "./calendars/fall_2026_2260_calendar.js";

export const courses = [
  /***START OF COURSE***/
   {
     crn: "MATH 2260",
     title: "Calculus 2",
     currentlyTeaching: true,
     timeslot: "TWF 8:15-9:35 // 9:55-11:15;",
     semester: "Fall 2026",
     location: "BOYD 202/322 //ADHLD 112;",
     syllabus: {
       name: "Course Syllabus",
       link: "https://drive.google.com/file/d/17Vw-8QAtEeWeje6Uw4NWltpp7MHEvQWs/view?usp=sharing"
     },
     resources: [
       {
         name: "Textbook",
         link: "https://openstax.org/details/books/calculus-volume-2"
       },
       {
         name: "Desmos (online graphing calculator)",
         link: "https://www.desmos.com/"
       },
       {
         name: "Table of derivatives/integrals",
         link: "https://drive.google.com/file/d/1s-lVC6rCYOYupfbGauJXALsMFs142tv3/view?usp=sharing"
       }
     ],
     materials: fall_2026_2260_materials,
     calendar: fall_2026_2260_calendar,
   },
  /***END OF COURSE***/
  //  /***START OF COURSE***/
  // {
  //   crn: "MATH 3200",
  //   title: "Combinatorics",
  //   currentlyTeaching: true,
  //   timeslot: "TR 12:45-2:00",
  //   semester: "Fall 2025",
  //   location: "BOYD 302",
  //   syllabus: {
  //     name: "Course Syllabus",
  //     link: "https://drive.google.com/file/d/1YX7dyQNOTTBf3AeCgKitYg1gMpi1Q8gm/view?usp=sharing"
  //   },
  //   resources: [
  //     {
        
  //     }
  //   ],
  //   materials: fall_2025_4670_materials,
  //   calendar: fall_2025_4670_calendar,
  // },
  // /***END OF COURSE***/

    // /***START OF COURSE***/
    // {
    //   crn: "MATH 3200",
    //   title: "Higher Math",
    //   currentlyTeaching: true,
    //   timeslot: "TR 11:35-12:55",
    //   semester: "Spring 2026",
    //   location: "BOYD 302",
    //   syllabus: {
    //     name: "Course Syllabus",
    //     link: "https://drive.google.com/file/d/12rsabB31EDmd3KVIeGdEGnouKGp1bTs5/view?usp=sharing"
    //   },
    //   resources: [
    //     {
    //       name: "Gradescope (homework submission)",
    //       link: "https://www.gradescope.com/"
    //     },
    //     {
    //       name: "Properties of the Integers",
    //       link: "https://drive.google.com/file/d/1h_Lhuem7JegrlQpW1oIPtulkq9flvRRw/view?usp=sharing"
    //     }
    //   ],
    //   materials: spring_2026_3200_materials,
    //   calendar: spring_2026_3200_calendar,
    // },
    // // /***END OF COURSE***/

  
  // /***START OF COURSE***/
  // {
  //   crn: "MATH 3100",
  //   title: "Sequences and Series",
  //   currentlyTeaching: true,
  //   timeslot: "9:00-9:50",
  //   semester: "Spring 2024",
  //   location: "DH 310",
  //   syllabus: {
  //     name: "Course Syllabus",
  //     link: "https://drive.google.com/file/d/1t5wMHFLZLZ3CtB_xna0scYVyzFxZ32WS/view?usp=sharing"
  //   },
  //   resources: [
  //     {
  //       name: "Textbook",
  //       link: "https://drive.google.com/file/d/1LCTXyP_fm4_EwiKyvhJ3WkT1V4HVqk-a/view?usp=sharing"
  //     },
  //     {
  //       name: "(NEW) Textbook",
  //       link: "https://link.springer.com/book/10.1007/978-1-4614-6271-2"
  //     }
  //   ], // Leaving resources list blank for now
  //   materials: spring_2024_3100_materials,
  //   calendar: spring_2024_3100_calendar,
  // },
  // /***END OF COURSE***/

    /***START OF COURSE***/
   {
     crn: "MATH 3200",
     title: "Higher Math",
     currentlyTeaching: true,
     timeslot: "MW/TR 11:35-12:55;",
     semester: "Fall 2026",
     location: "BOYD 322;",
     syllabus: {
       name: "Course Syllabus",
       link: "https://drive.google.com/file/d/1IbOHQB6PkORiU8rbScRkKabdWyO4LVGF/view?usp=sharing"
     },
     resources: [
         {
           name: "Gradescope (homework submission)",
           link: "https://www.gradescope.com/"
         },
         {
           name: "Properties of the Integers",
           link: "https://drive.google.com/file/d/1h_Lhuem7JegrlQpW1oIPtulkq9flvRRw/view?usp=sharing"
         }
       ],
     materials: fall_2026_3200_materials,
     calendar: fall_2026_3200_calendar,
   },
  /***END OF COURSE***/
  
];



// WEBPACK FOOTER //
// ./src/data/courses.js